import { agExtra } from "$root/ui-lib/table/default-configuration";
import type { AgGridReact } from "ag-grid-react";
import InstrumentTagClassificationSelect from "../../instruments/instrument-classification/InstrumentTagClassificationSelect";
import type { Instrument } from "../const";

/**
 * Groups the grid's rows by one of the user's instrument classifications. The grouping is applied
 * to the grid directly, so the control needs the grid instance rather than a value from the editor.
 */
export function GroupByClassificationSelect({ agGrid }: { agGrid: AgGridReact<Instrument> | null }): React.JSX.Element {
	const [groupByClassificationUuid, setGroupByClassificationUuid] = agExtra.useGroupByClassification(agGrid);

	return (
		<InstrumentTagClassificationSelect
			value={groupByClassificationUuid ?? null}
			onChange={setGroupByClassificationUuid}
		/>
	);
}
